import { IContent } from 'models/content.model';

export const content: IContent = {
  nl: {
    title: 'Hoe kunnen we je helpen?',
    label: '<strong>Hoe meer jij typt, hoe beter onze AI werkt.</strong>  Persoonlijke vragen zijn nog niet mogelijk.',
    placeholder: 'Begin met typen...',
    resetAriaLabel: 'Wissen',
    submitAriaLabel: 'Begin je gesprek',
    submitText: 'Begin je gesprek',
    popularTermsTitle: 'Populaire zoektermen:',
    popularTermUnstableWifiLabel: 'Instabiele wifi-verbinding',
    popularTermUnstableWifiQuery: 'Ik heb een instabiele wifi-verbinding met mijn Ziggo-apparaat.',
    popularTermUpgradeBundleLabel: 'Bundel upgraden',
    popularTermUpgradeBundleQuery: 'Ik wil mijn bundel upgraden.',
    popularTermSendWebmailLabel: 'Webmail verzenden',
    popularTermSendWebmailQuery: 'Ik wil een webmail verzenden.',
  },
  en: {},
};
